"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.COW_DragonWhelp_FlareAbilityHandler = exports.COW_DragonWhelp_FlareActorAbilityFactory = exports.COW_DragonWhelp_FlareAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
class COW_DragonWhelp_FlareAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.COW_DragonWhelp_Flare;
        this.__typeName = "COW_DragonWhelp_Flare";
    }
}
exports.COW_DragonWhelp_FlareAbilityArgs = COW_DragonWhelp_FlareAbilityArgs;
let COW_DragonWhelp_FlareActorAbilityFactory = class COW_DragonWhelp_FlareActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("COW_DragonWhelp_Flare", "OneEnemies", 0);
    }
};
COW_DragonWhelp_FlareActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("COW_DragonWhelp_Flare")
], COW_DragonWhelp_FlareActorAbilityFactory);
exports.COW_DragonWhelp_FlareActorAbilityFactory = COW_DragonWhelp_FlareActorAbilityFactory;
let COW_DragonWhelp_FlareAbilityHandler = class COW_DragonWhelp_FlareAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyMultiAttack({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: [
                {
                    targetId,
                    damages: [
                        AbilityDamage_1.AbilityDamage.Focus("Fire", 45)
                    ],
                    effects: [
                        {
                            duration: Duration_1.Duration.Turns(1),
                            targetId,
                            effect: new core_1.DarknessEffectArgs(2)
                        }
                    ]
                }
            ]
        });
    }
};
COW_DragonWhelp_FlareAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.COW_DragonWhelp_Flare)
], COW_DragonWhelp_FlareAbilityHandler);
exports.COW_DragonWhelp_FlareAbilityHandler = COW_DragonWhelp_FlareAbilityHandler;
